import React from 'react';
import './SvgIcon.scss';

/**
 * 顯示獨立 .svg 檔的 icon（用 Vite 的 ?raw 匯入，跟節慶特效的 svg 同一套做法）
 * svg 檔內的 stroke / fill 用 currentColor → 顏色跟著外層文字色；大小用 className 控制
 * 設計師要改圖直接覆蓋 .svg 檔即可
 *
 * 例：import refreshSvg from '../../assets/icons/actions/refresh.svg?raw';
 *     <SvgIcon svg={refreshSvg} className="refresh-icon" />
 */
const SvgIcon = ({ svg, className = '' }) => (
  <span
    className={`svg-icon ${className}`}
    aria-hidden="true"
    // 內容是 repo 內打包進來的靜態 svg 檔，不是使用者輸入
    dangerouslySetInnerHTML={{ __html: svg }}
  />
);

export default SvgIcon;
